import { Params } from '@angular/router';
import { SortDirection } from '@lib/core';

export enum PurchasingGroupSortBy {
    CODE = 'code',
    NAME = 'name',
}

export interface IPurchasingGroupListSortingDto {
    readonly sortBy?: string;
    readonly sortDirection?: string;
}

export class PurchasingGroupListSorting {
    public static readonly SORT_BY = 'sortBy';
    public static readonly SORT_DIRECTION = 'sortDirection';

    public readonly sortBy: PurchasingGroupSortBy;
    public readonly sortDirection: SortDirection;

    constructor(sortBy: PurchasingGroupSortBy = PurchasingGroupSortBy.CODE, sortDirection: SortDirection = SortDirection.ASC) {
        this.sortBy = sortBy;
        this.sortDirection = sortDirection;
    }

    public static default(): PurchasingGroupListSorting {
        return new PurchasingGroupListSorting();
    }

    public static fromRouteParams(params: Params): PurchasingGroupListSorting {
        return new PurchasingGroupListSorting(
            PurchasingGroupListSorting.resolveSortBy(params[PurchasingGroupListSorting.SORT_BY]),
            PurchasingGroupListSorting.resolveSortDirection(params[PurchasingGroupListSorting.SORT_DIRECTION]),
        );
    }

    public static fromDto(dto: IPurchasingGroupListSortingDto | null): PurchasingGroupListSorting {
        return new PurchasingGroupListSorting(
            PurchasingGroupListSorting.resolveSortBy(dto?.sortBy),
            PurchasingGroupListSorting.resolveSortDirection(dto?.sortDirection),
        );
    }

    public static hasRouteParams(params: Params): boolean {
        return (
            params[PurchasingGroupListSorting.SORT_BY] !== undefined ||
            params[PurchasingGroupListSorting.SORT_DIRECTION] !== undefined
        );
    }

    public toRouteParams(): Params {
        return {
            [PurchasingGroupListSorting.SORT_BY]: this.sortBy,
            [PurchasingGroupListSorting.SORT_DIRECTION]: this.sortDirection,
        };
    }

    public toDto(): IPurchasingGroupListSortingDto {
        return {
            sortBy: this.sortBy,
            sortDirection: this.sortDirection,
        };
    }

    private static resolveSortBy(value: unknown): PurchasingGroupSortBy {
        return value === PurchasingGroupSortBy.NAME ? PurchasingGroupSortBy.NAME : PurchasingGroupSortBy.CODE;
    }

    private static resolveSortDirection(value: unknown): SortDirection {
        return value === SortDirection.DESC ? SortDirection.DESC : SortDirection.ASC;
    }
}
